// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* FacultyIndividual Component CSS */

/* General styling */
.faculty-individual-detail {
    padding: 20px;
    background-color: #f9f9f9;
    color: #333;
    font-family: Arial, sans-serif;
}

/* Header section */
.faculty-individual-header {
    background-color: #007bff;
    color: #fff;
    padding: 15px;
    text-align: center;
    font-size: 24px;
    font-weight: bold;
    border-radius: 8px;
    margin-bottom: 20px;
}

/* Profile container */
.faculty-individual-profile-container {
    display: flex;
    gap: 20px;
    margin-top: 20px;
}

/* Right column */
.faculty-individual-right-column {
    flex: 1 1;
    background-color: #fdfdfd;
    padding: 20px;
    border: 1px solid #ddd;
    border-radius: 8px;
    text-align: center;
}

/* Image */
.faculty-individual-image {
    width: 150px;
    height: 150px;
    object-fit: cover;
    border-radius: 50%;
    margin-bottom: 15px;
}

/* Left column */
.faculty-individual-left-column {
    flex: 2.5 1;
    background-color: #fff;
    padding: 20px;
    border: 1px solid #ddd;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Text elements */
.faculty-individual-multiline-text {
    margin: 10px 0;
    font-size: 14px;
    line-height: 1.6;
}

/* Contact info */
.faculty-individual-contact-info {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 10px 0;
}

.faculty-individual-contact-info i {
    margin-right: 10px;
    color: #007bff;
}

.faculty-individual-contact-text a {
    color: #007bff;
    text-decoration: none;
    font-size: 14px;
}

.faculty-individual-contact-text a:hover {
    text-decoration: underline;
}

/* Vertical line */
.faculty-individual-vertical-line {
    width: 1px;
    background-color: #ddd;
    margin: 0 20px;
}



/* Responsive adjustments */
@media screen and (max-width: 768px) {
    .faculty-individual-profile-container {
        flex-direction: column;
    }

    .faculty-individual-left-column,
    .faculty-individual-right-column {
        max-width: 100%;
        flex: unset;
    }

    .faculty-individual-vertical-line {
        display: none;
    }

   
    
 
}
`, "",{"version":3,"sources":["webpack://./src/components/FacultyIndividual.css"],"names":[],"mappings":"AAAA,oCAAoC;;AAEpC,oBAAoB;AACpB;IACI,aAAa;IACb,yBAAyB;IACzB,WAAW;IACX,8BAA8B;AAClC;;AAEA,mBAAmB;AACnB;IACI,yBAAyB;IACzB,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA,iBAAiB;AACjB;IACI,SAAO;IACP,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,UAAU;AACV;IACI,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA,gBAAgB;AAChB;IACI,WAAS;IACT,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA,kBAAkB;AAClB;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,kBAAkB;AAClB;IACI,UAAU;IACV,sBAAsB;IACtB,cAAc;AAClB;;;;AAIA,2BAA2B;AAC3B;IACI;QACI,sBAAsB;IAC1B;;IAEA;;QAEI,eAAe;QACf,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;;;;;AAKJ","sourcesContent":["/* FacultyIndividual Component CSS */\r\n\r\n/* General styling */\r\n.faculty-individual-detail {\r\n    padding: 20px;\r\n    background-color: #f9f9f9;\r\n    color: #333;\r\n    font-family: Arial, sans-serif;\r\n}\r\n\r\n/* Header section */\r\n.faculty-individual-header {\r\n    background-color: #007bff;\r\n    color: #fff;\r\n    padding: 15px;\r\n    text-align: center;\r\n    font-size: 24px;\r\n    font-weight: bold;\r\n    border-radius: 8px;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n/* Profile container */\r\n.faculty-individual-profile-container {\r\n    display: flex;\r\n    gap: 20px;\r\n    margin-top: 20px;\r\n}\r\n\r\n/* Right column */\r\n.faculty-individual-right-column {\r\n    flex: 1;\r\n    background-color: #fdfdfd;\r\n    padding: 20px;\r\n    border: 1px solid #ddd;\r\n    border-radius: 8px;\r\n    text-align: center;\r\n}\r\n\r\n/* Image */\r\n.faculty-individual-image {\r\n    width: 150px;\r\n    height: 150px;\r\n    object-fit: cover;\r\n    border-radius: 50%;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n/* Left column */\r\n.faculty-individual-left-column {\r\n    flex: 2.5;\r\n    background-color: #fff;\r\n    padding: 20px;\r\n    border: 1px solid #ddd;\r\n    border-radius: 8px;\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n/* Text elements */\r\n.faculty-individual-multiline-text {\r\n    margin: 10px 0;\r\n    font-size: 14px;\r\n    line-height: 1.6;\r\n}\r\n\r\n/* Contact info */\r\n.faculty-individual-contact-info {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin: 10px 0;\r\n}\r\n\r\n.faculty-individual-contact-info i {\r\n    margin-right: 10px;\r\n    color: #007bff;\r\n}\r\n\r\n.faculty-individual-contact-text a {\r\n    color: #007bff;\r\n    text-decoration: none;\r\n    font-size: 14px;\r\n}\r\n\r\n.faculty-individual-contact-text a:hover {\r\n    text-decoration: underline;\r\n}\r\n\r\n/* Vertical line */\r\n.faculty-individual-vertical-line {\r\n    width: 1px;\r\n    background-color: #ddd;\r\n    margin: 0 20px;\r\n}\r\n\r\n\r\n\r\n/* Responsive adjustments */\r\n@media screen and (max-width: 768px) {\r\n    .faculty-individual-profile-container {\r\n        flex-direction: column;\r\n    }\r\n\r\n    .faculty-individual-left-column,\r\n    .faculty-individual-right-column {\r\n        max-width: 100%;\r\n        flex: unset;\r\n    }\r\n\r\n    .faculty-individual-vertical-line {\r\n        display: none;\r\n    }\r\n\r\n   \r\n    \r\n \r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
